<template>
  <div class="date-item-container" :class="containerStyle">
    <div
      class="date"
      :class="dateItem.date.isSame($dayjs(), 'day') ? 'is-today' : ''"
    >
      {{ dateItem.date.date() }}
    </div>
    <template v-if="!disabled">
      <div class="event-bar-wrap">
        <div
          v-if="dateItem.event[1]"
          @click="handleClickEvent(dateItem.event[1])"
          :style="dateItem.event[2] ? 'border-bottom:0;' : ''"
          class="event-bar"
          :class="isStartOrEnd(dateItem.event[1])"
        >
          {{ isShowTitle(dateItem.event[1]) }}
        </div>
      </div>
      <div class="event-bar-wrap">
        <div
         @click="handleClickEvent(dateItem.event[2])"
          v-if="dateItem.event[2]"
          class="event-bar"
          :class="isStartOrEnd(dateItem.event[2])"
        >
          {{ isShowTitle(dateItem.event[2]) }}
        </div>
      </div>
      <el-popover
        placement="top-end"
        width="198"
        trigger="click"
        ref="moreModel"
        v-if="moreCount"
      >
        <div class="more-model">
          <div class="title-wrap">
            <div class="title-date">{{ dateItem.date.format("MMM D") }}</div>
            <el-button @click="handleCloseModel" class="title-close" type="text"
              ><i class="el-icon-close"></i
            ></el-button>
          </div>
          <div class="sub-title">{{ `(${dateItem.date.format("dddd")})` }}</div>
          <div
            v-for="(eventIndex, index) in eventList"
            @click="handleClickEvent(dateItem.event[eventIndex])"
            style="height:28px;line-height:28px;"
            :style="index ? 'border-top:0' : ''"
            :key="eventIndex"
            class="event-bar"
            :class="
              isPromotionEvent(dateItem.event[eventIndex])
                ? 'is-promotion-event promotion-start-event promotion-end-event'
                : 'is-confirmed-event confirmed-start-event confirmed-end-event'
            "
          >
            {{ dateItem.event[eventIndex]?dateItem.event[eventIndex].eventTitle:'' }}
          </div>
        </div>
        <div slot="reference" class="more">{{ `${moreCount} more` }}</div>
      </el-popover>
    </template>
  </div>
</template>
<script>
export default {
  name: "dateItem",
  components: {},
  filters: {},
  watch: {
    update: {
      handler: function (e) {
        this.$forceUpdate();
      },
    },
  },
  props: {
    dateItem: {
      type: Object,
      default: { date: {},event:{} },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    update: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      callUpdate:false
    };
  },
  computed: {
    moreCount() {
      this.callUpdate = this.update
      const keyList = Object.keys(this.dateItem.event) || [];
      const moreList = keyList.filter((i) => {
        return i > 2;
      });
      return moreList.length;
    },
    isHoliday() {
      return (
        [0, 6].includes(this.dateItem.date.day()) || this.dateItem.isHoliday
      );
    },
    containerStyle() {
      let res = "";
      if (!this.disabled && this.isHoliday) res += "is-holiday ";
      if (this.disabled) res += "disabled ";
      return res;
    },
    eventList() {
      return Object.keys(this.dateItem.event) || [];
    },
  },
  methods: {
    isStartOrEnd(event) {
      let res = "";
      if (this.isPromotionEvent(event)) res += "is-promotion-event ";
      else res += "is-confirmed-event ";
      if (this.$dayjs(event.startEventDate).isSame(this.dateItem.date, "date"))
        res += this.isPromotionEvent(event)
          ? "promotion-start-event "
          : "confirmed-start-event ";
      if (this.$dayjs(event.endEventDate).isSame(this.dateItem.date, "date"))
        res += this.isPromotionEvent(event)
          ? "promotion-end-event "
          : "confirmed-end-event ";
      return res;
    },
    isShowTitle(event) {
      if (this.$dayjs(event.startEventDate).isSame(this.dateItem.date, "date"))
        return event.eventTitle;
      else return "";
    },
    isPromotionEvent(event) {
      return event && event.sourceType + "" == "1";
    },
    handleCloseModel() {
      this.$refs["moreModel"].doClose();
    },
    handleClickEvent(event){
      this.$emit("clickEvent",{...event})
    }
  },
};
</script>

<style lang="scss" scoped>
.date-item-container {
  width: calc(100% / 7);
  box-sizing: border-box;
  padding: 10px 0;
  height: 120px;
  border-right: 1px solid rgb(208, 213, 217);
  border-bottom: 1px solid rgb(208, 213, 217);
  font-weight: 600;
  font-size: 14px;
  .date {
    margin-left: 10px;
    line-height:21px;
  }
}
.disabled {
  background: repeating-linear-gradient(
    45deg,
    rgb(233, 233, 235),
    rgb(233, 233, 235) 1px,
    white 0,
    white 4px
  );
  color: rgb(163, 165, 167) !important;
}
.is-today {
  height: 21px;
  width: 21px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background: rgb(64, 158, 255);
}
.is-holiday {
  background: rgba(255, 0, 0, 0.05);
}
.is-promotion-event {
  border-top: 1px solid rgb(64, 158, 255);
  border-bottom: 1px solid rgb(64, 158, 255);
  background: rgb(205, 229, 255);
}
.is-confirmed-event {
  border-top: 1px solid rgb(26, 179, 148);
  border-bottom: 1px solid rgb(26, 179, 148);
  background: rgb(233, 244, 241);
}
.event-bar-wrap {
  height: calc((100% - 8px) / 3);
  width: 100%;
}
.event-bar{
  box-sizing: border-box;
  display: block;
  width: calc(100% + 1px);
  height: 100%;
  padding: 0 10px;
  color: rgb(48, 49, 51);
  font-weight: 400;
  font-size: 12px;
  overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
  cursor: pointer;
}
.confirmed-end-event {
  border-right: 1px solid rgb(26, 179, 148);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  width: 100%;
}
.confirmed-start-event {
  border-left: 1px solid rgb(26, 179, 148);
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.promotion-start-event {
  border-left: 1px solid rgb(64, 158, 255);
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.promotion-end-event {
  border-right: 1px solid rgb(64, 158, 255);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  width: 100%;
}
.more {
  display: flex;
  align-items: center;
  padding-left: 10px;
  font-size: 12px;
  color: rgb(48, 49, 51);
  height: calc((100% - 8px) / 3);
  cursor: pointer;
}
.more-model {
  min-height: 215px;
  padding: 8px;
  .title-wrap {
    max-height: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
    .title-date {
      font-size: 18px;
      font-weight: Bold;
      color: rgb(48, 49, 51);
    }
    .title-close {
      color: rgb(192, 196, 204);
      font-size: 24px;
    }
  }
  .sub-title {
    color: rgb(48, 49, 51);
    margin-bottom: 20px;
  }
}
</style>
